import script from "./IssueGeneralAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./IssueGeneralAccountView.vue?vue&type=script&setup=true&lang=js"

import "./IssueGeneralAccountView.vue?vue&type=style&index=0&id=3a9dd0c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a9dd0c2"]])

export default __exports__